module.exports = __webpack_public_path__ + "static/img/平面活动拍摄.70700b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10010/平面活动拍摄.png
// module id = HshO
// module chunks = 1